<template>
  <div id="dashboard-page" class="position-relative pb-5">
    <b-container class="mt-3">
      <b-row class="align-items-stretch">
        <b-col cols="12" lg="12" class="mb-4 portfolio-card">
          <b-col class="dash-card bg-dark p-4 dash shadow-xl">
            <b-row>
              <b-col cols="12" md="3">
                <div class="text-primary">
                  <div class="text-light">Total Portfolio</div>
                  <div class="d-flex">
                    <div class="" v-if="!checked">
                      <Money
                        :value="
                          dashboardInfo.investments.totalAmountInvested + dashboardInfo.investments.totalFarmInvestments || 0
                        "
                      />
                    </div>

                    <div class="" v-else>
                      <h3 class="mb-0">*** ***</h3>
                    </div>

                    <b-form-checkbox
                      switch
                      @change="togleBalance"
                      v-model="checked"
                      size="lg"
                      class="ml-4 pointer"
                    ></b-form-checkbox>
                  </div>

                  <div style="margin-top: 20px" class="btn-container boxes">
                    <router-link
                      to="/farms"
                      id="farm_for_u_btn"
                      class="btn btn-sm btn-dark text-warning dash-btn btn--shockwave is-active"
                    >
                      <i class="fa fa-bell-o text-warning"></i> Let's Farm For
                      You
                    </router-link>
                    <b-tooltip
                      target="farm_for_u_btn"
                      triggers="hover"
                      placement="bottom"
                    >
                      Earn as high as 35% ROI
                    </b-tooltip>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-col>

        <b-col cols="12" md="4" class="mb-4">
          <router-link to="farms">
            <div
              class="dash-card bg-orange p-4 rent shadow-xl text-dark d-flex align-items-end justify-content-between"
              style="height: 146px"
            >
              <div class="">
                <i class="fa fa-plus-circle" />
                <h6 class="h6-l">
                  Farm For Me
                </h6>
                <div style="font-size: 14px; margin-top: -10px">
                  Earn as high as 35%
                </div>
              </div>

              <div class="" v-if="!checked">
                <Money
                  :value="dashboardInfo.investments.totalFarmInvestments || 0"
                />
              </div>
              <div class="" v-else>
                <h3 class="mb-0">*** ***</h3>
              </div>
            </div>
          </router-link>
        </b-col>

        <b-col cols="12" md="4" class="mb-4">
          <router-link to="farms/funding">
            <div
              class="dash-card bg-primary p-4 own shadow-xl text-dark d-flex align-items-end justify-content-between"
            >
              <div class="">
                <i class="fa fa-plus-circle" />
                <h6 class="h6-l">Fund a Farm</h6>
              </div>
              <div class="" v-if="!checked">
                <Money
                  :value="dashboardInfo.investments.totalAmountInvested || 0"
                />
              </div>
              <div class="" v-else>
                <h3 class="mb-0">*** ***</h3>
              </div>
            </div>
          </router-link>
        </b-col>

        <b-col cols="12" md="4" class="mb-4">
          <router-link to="wallet">
            <div class="dash-card bg-dark p-4 wallet shadow-xl text-primary">
              <img src="@/assets/images/wallet.svg" height="30" />
              <h6 class="text-primary">Wallet</h6>
              <div class="" v-if="!checked">
                <Money
                  class="text-primary"
                  :value="dashboardInfo.walletBalance || 0"
                />
              </div>
              <div class="" v-else>
                <h3 class="mb-0">*** ***</h3>
              </div>
            </div>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="12" class="mb-4 portfolio-card">
          <NewPlans />
          <h4>
            <span align="right" class="badge badge-primary rgt">Swipe</span>
          </h4>
        </b-col>
      </b-row>
    </b-container>
    <InvestModal />
    <ReferralModal />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { UserService } from "@/services";
import { TransactionService } from "@/services";
//import FlipCountdown from "vue2-flip-countdown";
import { formatMoney } from "@/utils/helpers";
import NewPlans from "./components/Plans";

export default {
  name: "dashboard",
  data() {
    return {
      wslogo: require("@/assets/images/wealthsummitlogo.png"),
      dashboardInfo: {},
      display_event: false,
      checked: true,
      data: [
        {
          name: "Dates",
          data: [
            {
              label: "2016",
              value: 84000,
            },
            {
              label: "2017",
              value: 90000,
            },
            {
              label: "2018",
              value: 80000,
            },
            {
              label: "2019",
              value: 100000,
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState(["userObj"]),
  },
  components: {
    NewPlans
  },
  methods: {
    formatMoney,
    // togleBalance() {
    //   alert('hello')
    // },

    async togleBalance(){
      try{
        await TransactionService.toggleBalance();
      }catch(err){
        this.error = true
      }
    },

    async getTogleBalance(){
      try{
        const data = await TransactionService.getBalanceStatus();
        this.checked = data.hidebalance
      }catch(err){
        this.error = true
      }
    }
  },
  mounted() {
    this.getTogleBalance()
    // this.farmForMeSubTotal();
  },
  created() {
    const data = this.$route.meta.__data;
    this.dashboardInfo = data;
  },
  async beforeRouteEnter(to, from, next) {
    const { data } = await UserService.getDashboard();
    to.meta.__data = data;
    next();
  },
};
</script>

<style lang="scss" scoped>
.btn--shockwave {
  padding: 0 15px;
}

.dash-btn {
  margin-right: 10px;
  border: solid 1px #555;
}

.dash-card {
  position: relative;
  z-index: 2;
}

.dash-card i {
  padding: 15px 0;
  border-radius: 30px;
  color: #333;
}

.dash-card .h6-l {
  margin-top: 20px;
}

.dash-card::after {
  content: "";
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0.07;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
}

.dash-card.wallet::after {
  background-image: url("~@/assets/images/wallet.svg");
}

.dash-card.fund::after {
  background-image: url("~@/assets/images/investments.svg");
}

.dash-card.own::after {
  background-image: url("~@/assets/images/farms.svg");
}

.dash-card.rent::after {
  background-image: url("~@/assets/images/rental.svg");
  background-position: center;
}

.dash-card.dash::after {
  background-image: url("~@/assets/images/ether2.svg");

  opacity: 1;
  background-position: bottom;
  background-color: #333;
  border-radius: 5px;
}

.action-btn {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
  border-radius: 10px;

  &:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
    transform: scale(0.98);
  }
  &:focus {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
    transform: scale(0.95);
  }
}

.icon-fx {
  background-color: #f266434f;
  padding: 10px;
  border-radius: 50%;
  // margin-bottom: 10px;
}

.carousel-caption {
  padding: 1.5rem 1.5rem 0rem 1.5rem;
  text-align: left;
  right: 0;
  left: 0;
  margin: 0;
  text-shadow: none;
  color: #000000;
}

.flip-card__top[data-v-72281230],
.flip-card__bottom[data-v-72281230],
.flip-card__back-bottom[data-v-72281230],
.flip-card__back[data-v-72281230]::before,
.flip-card__back[data-v-72281230]::after {
  color: #f26743 !important;
}

.chart {
  width: 100%;
  height: 200px;
}

$spacing__base: 1.6rem;
$easing: cubic-bezier(0.33, 0.33, 0.33, 1);
$background: darken(#daecf3, 12);
$gradient_end: darken(#d7edec, 8);

@mixin afterBg {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border-radius: 50%;
}

// Shockwave
.btn--shockwave.is-active {
  animation: shockwaveJump 1s ease-out infinite;

  &:after {
    @include afterBg;
    animation: shockwave 1s 0.65s ease-out infinite;
  }

  &:before {
    @include afterBg;
    animation: shockwave 1s 0.5s ease-out infinite;
  }
}

@keyframes shockwaveJump {
  0% {
    transform: scale(1);
  }
  40% {
    transform: scale(1.08);
  }
  50% {
    transform: scale(0.98);
  }
  55% {
    transform: scale(1.02);
  }
  60% {
    transform: scale(0.98);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes shockwave {
  0% {
    transform: scale(1);
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.15), inset 0 0 1px rgba(0, 0, 0, 0.15);
  }
  95% {
    box-shadow: 0 0 50px rgba(0, 0, 0, 0), inset 0 0 30px rgba(0, 0, 0, 0);
  }
  100% {
    transform: scale(2.25);
  }
}
</style>
